import { render, staticRenderFns } from "./VerticalMenuItem.vue?vue&type=template&id=60bdc38e&"
import script from "./VerticalMenuItem.vue?vue&type=script&lang=ts&"
export * from "./VerticalMenuItem.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalMenuItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports